import { render, staticRenderFns } from "./pricing-quote.vue?vue&type=template&id=70a774c1&scoped=true"
import script from "./pricing-quote.js?vue&type=script&lang=js&external"
export * from "./pricing-quote.js?vue&type=script&lang=js&external"
import style0 from "./pricing-quote.vue?vue&type=style&index=0&id=70a774c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a774c1",
  null
  
)

export default component.exports